import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

angular
  .module('data-ng-staff-todos')
  .factory(
    'loadStaffTodoItemCommand',
    (
      defineCommand: IDefineCommand,
      getJwtTokenCommand: ICommand,
      $http: ng.IHttpService,
      appConfigModel: any
    ): ICommand => {
      return defineCommand('loadStaffTodoItemCommand', (deferred: ng.IDeferred<IQuery[]>, staffTodoID: any): void => {
        const campusUrl = appConfigModel.getConfigProperty(`core-campus_url`);
        if (_4.isEmpty(campusUrl)) {
          deferred.resolve();
        } else {
          getJwtTokenCommand().then((token: any) => {
            let config = {
              url: campusUrl + '/api/v3/student_resources/reminders/' + (staffTodoID || ''),
              method: 'GET',
              headers: {
                Authorization: token.access_token,
                isCampusAPI: true
              }
            };
            $http(config)
              .then((response: any) => {
                deferred.resolve(response.data.data.reminder);
              })
              .catch((error: any) => {
                deferred.reject(error);
              });
          });
        }
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-staff-todos/src/commands/load_staff_todo_item_command.ts